import React from 'react';
import WorkflowStepTile from './WorkflowStepTile';
export default function JobStepTile(props){ return <WorkflowStepTile {...props} />; }
